module.exports = __webpack_public_path__ + "media/images/course/5-7fea21d904dc47b471fd8f2612e8cf21.png";